import React from 'react';

import styled from 'styled-components';

import { Button, Icon, View, colors } from '@fairygodboss/ui';

import AuthWrapperComponent from '../../../CallToAction/AuthWrapperComponent/AuthWrapperComponent';

const MobileButtonWrap = styled(View)`
    width: 100%;

    .component-CallToAction-AuthWrapperComponent {
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
    }

    .component-CallToAction-AuthWrapperComponent > .wrap-auth-div {
        align-self: stretch;
        width: auto;
    }

    .component-CallToAction-AuthWrapperComponent > .wrap-auth-div button {
        width: 100%;
    }
`;

export const ApplyButtonGroup = ({
    handleCompanyApplyClick,
    handleSaveClick,
    isSaved,
    position,
    saveButtonText,
    applyButtonText,
}) => (
    <>
        {/* MOBILE */}
        <MobileButtonWrap display={{ _: 'flex', sm: 'none' }}>
            <Button
                data-qa={`Jobs-apply-button${position ? `-${position}` : ''}`}
                size="medium"
                mr="4px"
                width="calc((100% * 2/3) - 4px)"
                onPress={() => {
                    if (handleCompanyApplyClick) {
                        handleCompanyApplyClick(position);
                    }
                }}
            >
                Apply on company site
            </Button>
            <AuthWrapperComponent
                callToActionHash="save-job"
                loginTrigger="save-job"
            >
                <Button
                    data-qa={`Jobs-save-button${
                        position ? `-${position}` : ''
                    }`}
                    flexDirection="column"
                    flexGrow={1}
                    minWidth="auto"
                    pt="4px"
                    pb="3px"
                    leftIcon={
                        <Icon
                            display="inline-block"
                            mx="auto"
                            variant="heart_16"
                            outlineColor={colors.secondary[80]}
                            fillColor={
                                isSaved ? colors.secondary[80] : undefined
                            }
                        />
                    }
                    variant="secondaryText"
                    size="medium"
                    onPress={handleSaveClick}
                >
                    Save for later
                </Button>
            </AuthWrapperComponent>
        </MobileButtonWrap>

        {/* DESKTOP */}
        <View display={{ _: 'none', sm: 'flex' }}>
            <Button
                data-qa={`Jobs-apply-button${position ? `-${position}` : ''}`}
                size="medium"
                mr="16px"
                minWidth="120px"
                onPress={() => {
                    if (handleCompanyApplyClick) {
                        handleCompanyApplyClick(position);
                    }
                }}
            >
                {applyButtonText || 'Apply on company site'}
            </Button>
            <AuthWrapperComponent
                callToActionHash="save-job"
                loginTrigger="save-job"
            >
                <Button
                    data-qa={`Jobs-save-button${
                        position ? `-${position}` : ''
                    }`}
                    onPress={handleSaveClick}
                    minWidth="95px"
                    leftIcon={
                        !isSaved ? (
                            <Icon
                                variant="heartOutline_16"
                                outlineColor={colors.secondary[80]}
                            />
                        ) : (
                            <Icon
                                variant="heartFilled_16"
                                outlineColor={colors.secondary[80]}
                                fillColor={colors.secondary[80]}
                            />
                        )
                    }
                    size="medium"
                    variant="secondary"
                >
                    {saveButtonText || 'Save for later'}
                </Button>
            </AuthWrapperComponent>
        </View>
    </>
);
